// src/projects/projectHydration.js

import { useProjectStore } from "../stores/useProjectStore";
import { fetchWithAuth } from "../api/fetchWithAuth";

/**
 * Validate active project against backend.
 * Does NOT auto-reset identity.
 */
export async function hydrateProjectContext() {
  try {
    const r = await fetchWithAuth("/api/v1/project/context");
    if (!r.ok) return; // silently ignore

    const ctx = await r.json();

    // If backend returns resolved project info, update store
    if (ctx?.id) {
      useProjectStore.getState().setActiveProject(ctx);
    }

  } catch {
    // DO NOT reset to global
    // Backend validation should handle authorization at route level
  }
}

/**
 * Load available projects.
 * Does NOT auto-reset persisted project.
 */
export async function hydrateProjects() {
  const r = await fetchWithAuth("/api/v1/projects/available");
  if (!r.ok) return;

  const projects = await r.json();
  const store = useProjectStore.getState();

  store.setProjects(projects);

  // Resolve active project if valid
  const { activeProjectId } = store;

  if (activeProjectId && activeProjectId !== "global") {
    const match = projects.find(p => p.id === activeProjectId);
    if (match) {
      store.setActiveProject(match);
    }
  }

  // DO NOT auto-reset if not found
}